// /* eslint-diable */
// import { KeyValue, Secret, Password, Key, Sdk, Certificate, PrivateKey } from "Wasm/izweb";
import { updatePinOps, deletePin, listUserPins, sendAddPinWithOps } from "@induz/sdk";

// export const addKVPair = async (path, keys, values, ttl) => {
//     if(!path || !keys || !values || !ttl) {
//         throw new Error("Path, keys, and values are required to add a key-value pair.");
//     }
//     if (keys.length !== values.length) {
//         throw new Error("Keys and values must have the same length.");
//     }
//     return await KeyValue.add_keyvalue(path, keys, values, ttl);
// };
// export const listKVPairs = async () => {
//     return await Secret.list_secrets("keyvalue");
// };
// export const updateKVPair = async (path, key, value, expiry) => {
//     if (!path || !key || !value) {
//         throw new Error("Path, key, and value are required to update a key-value pair.");
//     }
//     return await KeyValue.update_keyvalue(path, key, value, expiry);

// };
// export const deleteSecret = async (path) => {
//     if (!path) {
//         throw new Error("Path is required to delete a secret.");
//     }
//     return await Secret.destroy_secret(path);
// };

// export const addPassword = async (path, username, password, url, totpSecret, notes, expiry) => {
//     if (!path || !username || !password) {
//         throw new Error("Path, username, and password are required to add a password.");
//     }
//     return await Password.add_password(path, username, password, url, totpSecret, notes, expiry);
// };

// export const updatePassword = async (path, username, password, url, totpSecret, notes, expiry) => {
//     if (!path || !username || !password) {
//         throw new Error("Path, username, and password are required to update a password.");
//     }

//     return await Password.update_password(path, username, password, url, totpSecret, notes, expiry);
// };

// export const listPasswords = async () => {
//     return await Secret.list_secrets("password");
// };
// export const addPrivateKey = async (path, key, expiry) => {
//     if (!path || !key) {
//         throw new Error("Path and key are required to add a private key.");
//     }

//     return await PrivateKey.add_privatekey(path, key, expiry);
// };
// export const updatePrivateKey = async (path, key, expiry) => {
//     if (!path || !key) {
//         throw new Error("Path and key are required to update a private key.");
//     }
//     return await PrivateKey.update_privatekey(path, key, expiry);
// };

// export const listPrivateKeys = async () => {
//     return await Secret.list_secrets("privatekey");
// };


// export const addCertificate = async (path, cert, expiry) => {
//     if (!path || !cert) {
//         throw new Error("Path and certificate are required to add a certificate.");
//     }
//     return await Certificate.add_certificate(path, cert, expiry);
// };
// export const listCertificates = async () => {
//     return await Secret.list_secrets("certificate");
// };
// export const updateCertificate = async (path, cert, expiry) => {
//     if (!path || !cert) {
//         throw new Error("Path and certificate are required to update a certificate.");
//     }

//     return await Certificate.update_certificate(path, cert, expiry);
// };

/**
 * Asynchronously retrieves the list of user pins.
 *
 * @async
 * @function
 * @return {Promise<PinInListSDK[]>} A promise that resolves to an array of PinInList objects.
 */
export const callListPins = async () => {
    try {
        // console.log("Fetching user pins...");
        const pins = await listUserPins();

        // Define operation groups that should be considered as a single permission
        const operationGroups = {
            "Read File/Folder": [17, 21, 25],
            "Write File/Folder": [17, 22, 23, 24, 30],
            "Copy File/Folder": [17, 30, 52],
            "Move File/Folder": [17, 50, 51],
            "AddPin": [15],
            "UpdatePin": [84],
            "DeletePin": [54],
            "ListPins": [91]
        };

        // Helper function to check if an array contains all elements from another array
        const containsAll = (arr, target) => target.every(v => arr.includes(v));

        // Process each pin to determine its operations
        pins.forEach(pin => {
            if (Array.isArray(pin.allowedPinOps)) {
                let opNames = [];

                // Check each operation group
                for (const [opName, opCodes] of Object.entries(operationGroups)) {
                    // If the pin's ops contain all the codes for this operation group
                    if (containsAll(pin.allowedPinOps, opCodes)) {
                        opNames.push(opName);
                    }
                }

                // Check if all operation groups are present
                const allOperationGroups = Object.keys(operationGroups);
                if (opNames.length === allOperationGroups.length) {
                    opNames = [];
                    opNames.push("All Operations");
                }

                pin.allowedPinOpsNames = opNames;
            } else {
                pin.allowedPinOpsNames = [];
            }
        });

        // console.log("List of user pins:", pins);
        return pins;
    } catch (error) {
        console.error("Failed to list user pins:", error);
        throw error;
    }
};
export const callDeletePin = async (PinId) => {
    if (!PinId) {
        console.error("callDeletePin: PinId is required");
        return {
            error: true,
            message: "Pin ID is required for deletion"
        };
    }
    try {
        const resp = await deletePin(PinId);
        if (resp instanceof Error) {
            return {
                error: true,
                message: resp.message || "Failed to delete pin"
            };
        }
        if (resp && typeof resp === "object" && resp.error) {
            return {
                error: true,
                message:
                    resp.message ||
                    (typeof resp.error === "string" ? resp.error : "Failed to delete pin")
            };
        }
        return { error: false, data: resp };
    } catch (error) {
        console.warn("SDK deletePin failed:", error);
        return {
            error: true,
            message:
                error?.message ||
                "We could not delete the pin right now. Please try again."
        };
    }
};
export const callUpdatePin = async (pinName, uuidsHexa, selectedOperations) => {
    // Convert selectedOperations (string[]) to operation IDs (number[]) as in addYsafePIN
    const ops = [];
    selectedOperations.forEach(item => {
        if (item === "All Operations") {
            //  do nothing
        }
        else if (item === "Read File/Folder") {
            ops.push(17, 21, 25);
        }
        else if (item === "Write File/Folder") {
            ops.push(17, 22, 23, 24, 30);
        }
        else if (item === "Copy File/Folder") {
            ops.push(17, 30, 52);
        }
        else if (item === "Move File/Folder") {
            ops.push(17, 50, 51);
        }
        else if (item === "AddPin") {
            ops.push(15);
        }
        else if (item === "UpdatePin") {
            ops.push(84);
        }
        else if (item === "DeletePin") {
            ops.push(54);
        }
        else if (item === "ListPins") {
            ops.push(91);
        }
    });
    try {
        // console.log("uuids hexa", uuidsHexa);
        const resp = await updatePinOps(pinName, ops, uuidsHexa === undefined ? [] : uuidsHexa);
        // console.log("update pin response", resp);
        return resp;
    } catch (error) {
        console.error("Failed to update pin:", error);
        return error;
    }
};

// export const deletePinOfUser = async () => {
/**
 * Adds a Ysafe PIN with the specified operations and returns the response as an array of bytes (Uint8Array).
 * @param {string} isTypeSelect
 * @param {number} ttl
 * @param {string} pin
 * @param {string[]} selectedOperations
 * @param {string} [name=""]
 * @param {string|string[]} uuidsHexa
 * @return {Promise<Uint8Array>} The response as an array of bytes.
 */
export const addYsafePIN = async (isTypeSelect, ttl, pin, selectedOperations, name = "", uuidsHexa) => {
    if (!pin || !selectedOperations || selectedOperations.length === 0) {
        throw new Error("PIN and selected operations are required to add a Ysafe PIN.");
    }
    const ops = [];
    selectedOperations.forEach(item => {
        if (item === "All Operations") {
            //  do nothing
        }
        else if (item === "Read File/Folder") {
            ops.push(17, 21, 25);
        }
        else if (item === "Write File/Folder") {
            ops.push(17, 22, 23, 24, 30);
        }
        else if (item === "Copy File/Folder") {
            ops.push(17, 30, 52);
        }
        else if (item === "Move File/Folder") {
            ops.push(17, 50, 51);
        }
        else if (item === "AddPin") {
            ops.push(15);
        }
        else if (item === "UpdatePin") {
            ops.push(84);
        }
        else if (item === "DeletePin") {
            ops.push(54);
        }
        else if (item === "ListPins") {
            ops.push(91);
        }
    });
    // console.log("about to add pin", pin, ops, name, uuidsHexa);
    let uuidsBytes;
    try {
        // Helper to convert hex string to Uint8Array
        const hexToBytes = (hex) => {
            if (!hex || typeof hex !== "string") return new Uint8Array();
            const bytes = [];
            for (let c = 0; c < hex.length; c += 2) {
                bytes.push(parseInt(hex.substr(c, 2), 16));
            }
            return new Uint8Array(bytes);
        };

        // Support both single hex string and array of hex strings

        if (Array.isArray(uuidsHexa)) {
            uuidsBytes = uuidsHexa.map(hexToBytes);
        } else {
            uuidsBytes = hexToBytes(uuidsHexa);
        }
        // console.log("Decoded uuidsBytes:", uuidsBytes);
    } catch (e) {
        console.error("Failed to decode uuidsHexa:", e);
        throw new Error("Invalid uuidsHexa format");
    }

    const resp = await sendAddPinWithOps(pin, ops, uuidsBytes, name === "" ? null : name, ttl);
    // console.log("add pin response", resp);
    // Ensure the return type is Uint8Array (array of bytes)
    if (resp instanceof Uint8Array) {
        return resp;
    }
    // If resp is an ArrayBuffer, convert to Uint8Array
    if (resp instanceof ArrayBuffer) {
        return new Uint8Array(resp);
    }
    // If resp is array-like, convert to Uint8Array
    if (Array.isArray(resp)) {
        return new Uint8Array(resp);
    }
    throw new Error("Unexpected response type from sendAddPinWithOps");
};

// export const addToken = async (path, key, minSize, maxSize, expiry) => {
//     if (!path || !key ) {
//         throw new Error("Path, key, minSize, and maxSize are required to add a token.");
//     }
//     return await Key.add_alphanumeric_key(path, key, minSize, maxSize, expiry);
// };


// export const updateToken = async (path, key, minSize, maxSize, expiry) => {
//     if (!path || !key || !minSize || !maxSize) {
//         throw new Error("Path, key, minSize, and maxSize are required to update a token.");
//     }
//     return await Key.update_alphanumeric_key(path, key, minSize, maxSize, expiry);
// };


// export const listTokens = async () => {
//     return await Secret.list_secrets("token");
// };

export const addKVPair = async (path, keys, values, ttl) => { };
export const listKVPairs = async () => { };
export const updateKVPair = async (path, key, value, expiry) => { };
export const deleteSecret = async (path) => { };
export const addPassword = async (path, username, password, url, totpSecret, notes, expiry) => { };
export const updatePassword = async (path, username, password, url, totpSecret, notes, expiry) => { };
export const listPasswords = async () => { };
export const addPrivateKey = async (path, key, expiry) => { };
export const updatePrivateKey = async (path, key, expiry) => { };
export const listPrivateKeys = async () => { };
export const addCertificate = async (path, cert, expiry) => { };
export const listCertificates = async () => { };
export const updateCertificate = async (path, cert, expiry) => { };
// export const addYsafePIN = async (isTypeSelect, ttl, pin, selectedOperations) => {};
export const addToken = async (path, key, minSize, maxSize, expiry) => { };
export const updateToken = async (path, key, minSize, maxSize, expiry) => { };
export const listTokens = async () => { };